import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';

import ACFLink from './../ACFLink';
import Container from './../Container';
import Html from './../Html';
import css from 'css';

class TitleWithCustomContent extends Component {

    constructor() {
        super();

        this.state = {

        }
    }

    _renderContent(content) {
        const data = content[0];
        if(data) {
            switch(data.acf_fc_layout) {
                case 'text_and_link': 
                    return this._renderTextAndLink(data);
                case 'content_grid': 
                    return this._renderContentGrid(data);
                case 'content_image_grid': 
                    return this._renderContentImageGrid(data);
                default:
                    return '';
            }
        }
    }

    _renderTextAndLink(data) {
        return (
            <TextAndLinkWrapper withLink={data.link.url}>
                {/*<p dangerouslySetInnerHTML={{ __html: data.text }} />*/}
                <Html>{data.text}</Html>
                <ACFLink className="bottom-link" data={data.link} />
            </TextAndLinkWrapper>
        )
    }

    _renderContentGrid(data) {
        if(data.content_grid[0]) {
            return (
                <ContentGridWrapper>
                    {data.content_grid.map((item, i) => {
                        return (
                            <ContentGridItem key={i}>
                                <strong>{item.title}</strong>
                                <span>{item.description}</span>
                                <ACFLink data={item.link} />
                            </ContentGridItem>
                        )
                    })}
                </ContentGridWrapper>
            )
        }
    }

    _renderContentImageGrid(data) {
        if(data.content_image_grid[0]) {
            return (
                <ContentGridWrapper>
                    {data.content_image_grid.map((item, i) => {
                        return (
                            <ContentGridItem key={i} withImage>
                                {item.image && 
                                    <div>
                                        <img src={item.image.sizes.medium} alt="Logo" />
                                    </div>
                                }
                                <div>
                                    <ACFLink data={item.link_1} />
                                    <br/>
                                    <ACFLink data={item.link_2} />
                                </div>
                            </ContentGridItem>
                        )
                    })}
                </ContentGridWrapper>
            )
        }
    }

    render() {
        const { data } = this.props;

        //console.log('TitleWithCustomContent:',data);

        return (
            <ModuleWrapper background={data.background} border={data.border}>
                <Container>
                    <Title dangerouslySetInnerHTML={{ __html: data.title }} />
                    <Content>{this._renderContent(data.content)}</Content>
                </Container>
            </ModuleWrapper>
        );
    }
}

export default withRouter(TitleWithCustomContent);

const ModuleWrapper = styled.div`
    background-color: ${props => props.background === 'white' ? '#fff' : css.colors.gray};
    > div {
        padding-top:90px;
        padding-bottom: 90px;
        display:flex;
        position:relative;
        justify-content: space-between;
        ${props => props.border ? `
            &:after {
                content: '';
                height:1px;
                bottom:0;
                left:0;
                right:0;
                background: #818181;
                display:block;
                position:absolute;
                @media (max-width: 1252px) {
                    left: 25px;
                    right: 25px;
                }
            }
        ` : ``};
        @media (max-width: 1080px) {
            padding-top:80px;
            padding-bottom: 80px;
        }
        @media (max-width: 768px) {
            padding-top:40px;
            padding-bottom: 40px;
            flex-direction:column;
        }
        @media (max-width: 768px) {
            padding-top:30px;
            padding-bottom: 40px;
        }
    }
`

const Title = styled.div`
    width:40%;
    font-size:43px;
    line-height: 50px;
    font-family: ${css.fonts.bg_bold};
    color:#000;
    padding-right:30px;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top:-8px;
    @media (max-width: 1080px) {
        font-size:30px;
        margin-top:-4px;
        line-height: 1.2;
    }
    @media (max-width: 768px) {
        width:100%;
        margin-bottom:30px;
        padding-right:0;
        margin-top:0px;
    }
    @media (max-width:480px) {
        font-size: 26px;
        line-height: 31px;
    }
`

const Content = styled.div`
    width: ${css.sizes.rightColumn};
    @media (max-width: 768px) {
        width:100%;
    }
`

const TextAndLinkWrapper = styled.div`
    .bottom-link {
        font-family: ${css.fonts.bg_regular};
        font-size:18px;
    }
`

const ContentGridWrapper = styled.ul`
    display:flex;
    flex-wrap: wrap;
    justify-content: space-between;
    &:after {
        content: "";
        flex: 0 1 28%;
    }

    @media (max-width: 1080px) {
        &:after {
            flex: 0 1 45%;
        }
    }
    @media (max-width: 480px) {
        &:after {
            display:none;
        }
    }
`

const ContentGridItem = styled.li`
    width: 28%;
    padding-bottom: 25px;

    @media (max-width: 1080px) {
        width:45%;
    }

    @media (max-width: 480px) {
        width:100%;
        padding-bottom: 0;
        margin-bottom:20px;
        &:last-child {
            margin-bottom:0;
        }
    }

    img {
        width:75px;
        height:auto;
        margin-bottom:20px;
    }
    strong {
        display:block;
        font-weight:500;
        margin-bottom:4px;
        font-weight: normal;
        font-family: ${css.fonts.bg_bold};
        font-size:18px;
    }
    span {
        display:block;
        font-size:18px;
        margin-bottom:4px;
        font-family: ${css.fonts.bg_regular};
    }
    a {
        color:#848484;
        font-size:14px;
        font-family: ${css.fonts.bg_regular};
        border-bottom: 1px solid transparent;
        &:hover {
            border-bottom: 1px solid #9e9e9e;
        }
    }

    ${props => props.withImage ? `
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        a {
            display:inline-block;
            margin-bottom:5px;
        }

        @media (max-width: 480px) {
            flex-direction: row;
            justify-content: flex-start;
            img {
                margin-right:20px;
                margin-bottom:0;
            }
        }

    ` : ``}
`


// WEBPACK FOOTER //
// ./src/partials/modules/TitleWithCustomContent.js